export default (axios, baseURL) => ({
  list(page) { return axios.get(`${baseURL}/api/contents/${page}`); },
  createSection(data) { return axios.post(`${baseURL}/api/content-sections`, data); },
  updateSection(id, data) { return axios.put(`${baseURL}/api/content-sections/${id}`, data); },
  deleteSection(id) { return axios.delete(`${baseURL}/api/content-sections/${id}`); },
  createDocument(data) { return axios.post(`${baseURL}/api/content-documents`, data); },
  updateDocument(id, data) { return axios.post(`${baseURL}/api/content-documents/${id}`, data); },
  deleteDocument(id) { return axios.delete(`${baseURL}/api/content-documents/${id}`); },
});
